import { $_bridge } from '@/nms/plugins/bridge.js'

const getDefaultBaseState = () => {
  return {
    auth: {
      subsystems: ['common'],
      methods: ['nms', 'keycloak', 'LDAP'],
    },
    baseline: {
      journal: {
        pages: ['states', 'actions', 'events', 'service', 'system journal', 'audit'],
      }
    },
    location: {
      create: {
        entity: {
          types: [
            { value: 'service', name: 'Сервис' },
            { value: 'location', name: 'Локация' },
            { value: 'cabinet', name: 'Стойка' },
            { value: 'device', name: 'Устройство' },
          ],
        } 
      },
    },
    device: {
      update: {
        rules: {
          snmp: {
            noVer: {
              community: 'false',
              user: 'false',
              level: 'false',
              authprotocol: 'false',
              authkey: 'false',
              privprotocol: 'false',
              privkey: 'false',
            },
            ver1: {
              community: 'true',
              user: 'false',
              level: 'false',
              authprotocol: 'false',
              authkey: 'false',
              privprotocol: 'false',
              privkey: 'false',
            },
            ver3: {
              'no auth, no privacy': {
                community: 'false',
                user: 'true',
                level: 'true',
                authprotocol: 'false',
                authkey: 'false',
                privprotocol: 'false',
                privkey: 'false',
              },
              'auth, no privacy': {
                community: 'false',
                user: 'true',
                level: 'true',
                authprotocol: 'true',
                authkey: 'true',
                privprotocol: 'false',
                privkey: 'false',
              },
              'auth, privacy': {
                community: 'false',
                user: 'true',
                level: 'true',
                authprotocol: 'true',
                authkey: 'true',
                privprotocol: 'true',
                privkey: 'true',
              },
            },
          },
        },
      }
    },
    equipment: {
      measures: {
        view: {
          places: ['configuration', 'params', 'console', 'manage', 'vinteo']
        },
      },
      tree: {
        bar: {
          view: {
            places: ['params', 'console', 'webaccess', 'manage', 'vinteo', 'configuration', 'inventory'],
          },
        },
      },
    },
    mapCenter: [55.755919, 37.617589],
    statuses: {
      defaultStatuses: ['unknown', 'warning', 'alarm', 'damage'],
    },
    
  }
}

// Persistent-свойства (не сбрасываются)
const getPersistentState = () => {
  return {

  }
}

// Полное начальное состояние
const getDefaultState = () => {
  return {
    ...getDefaultBaseState(),
    ...getPersistentState(),
  }
}

const state = getDefaultState()

export default {
  state,

  mutations: {
    MUTATION_NAME(state: any, data: any) {
      
    },
  },

  actions: {
    actionName({ commit }: any, data: any | null) {
      commit('ACTIVE_RECORD', data)
    },
  },

  getters: {
    getAuthNails: (state: any) => state.auth,
    getBaselineNails: (state: any) => state.baseline,
    getLocationNails: (state: any) => state.location,
    getDeviceNails: (state: any) => state.device,
    getEquipmentNails: (state: any) => state.equipment,
    getMapCenter: (state: any) => state.mapCenter,
    getDefaultStatuses: (state: any) => state.statuses.defaultStatuses,
  },
}